import * as Yup from 'yup';
import { useState, useEffect, useContext } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { mask, unMask } from "remask";


// material
import { Stack, TextField, MenuItem, Alert} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../../components/Button';

import {api, reiniciarToken, editarFornecedores, visualizarFornecedores} from '../../../services/api';

// context
import { AuthContext } from '../../../contexts/auth';

// ----------------------------------------------------------------------

export default function EditarFOrnecedorForm() {

  const {id} = useParams();
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const RegisterSchema = Yup.object().shape({
    nome_fantasia: Yup.string().min(2, 'Muito Pequeno!').max(500, 'Muito Longo!').required('Nome é obrigatório'),
    razao_social: Yup.string(),
    endereco: Yup.string(),
    numero: Yup.number(),
    bairro: Yup.string(),
    cidade: Yup.string(),
    estado: Yup.string(),
    uf: Yup.string(),
    cep: Yup.string(),
    tipo_pessoa: Yup.string().required('Tipo de Pessoa é obrigatório'),
    cnpj_cpf: Yup.string(),
    inscricao_municipal: Yup.string(),
    inscricao_estadual: Yup.string(),
    email: Yup.string().email('Informe um email válido'),
    contato: Yup.string().required('Contato é obrigatório'),
    telefone_celular: Yup.string().required('Celular é obrigatório'),
    telefone_fixo: Yup.string(),
  });

  const formik = useFormik({
   initialValues: {
        nome_fantasia: '',
        razao_social: '',
        endereco: '',
        numero: null,
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        uf: '',
        cep: '',
        tipo_pessoa: '',
        cnpj_cpf: '',
        inscricao_municipal: '',
        inscricao_estadual: '',
        email: '',
        contato: '',
        telefone_celular: '',
        telefone_fixo: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const handleSubmit = async e => {
    e.preventDefault();

    const response = await editarFornecedores(id, formik.values);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    };
  }

  const { errors, touched, isSubmitting, getFieldProps, handleBlur, handleChange, setFieldValue} = formik;

  useEffect(() => {
      const getFornecedor = async () => {
        const retorno = await reiniciarToken();
        if(retorno.erro === true) {
          if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
            logout();
          }
        }else{
          localStorage.setItem("token", retorno.data.token);
          api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
        }
        
        const response = await visualizarFornecedores(id);
        if(response.erro === true) {
          if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
            logout();
          }else {
            setStatus({
              type: "erro",
              mensagem: response.mensagem
            })
          }
        };

        const campos = ['nome_fantasia',
                        'razao_social',
                        'endereco',
                        'numero',
                        'complemento',
                        'bairro',
                        'cidade',
                        'estado',
                        'uf',
                        'cep',
                        'tipo_pessoa',
                        'cnpj_cpf',
                        'inscricao_municipal',
                        'inscricao_estadual',
                        'email',
                        'contato',
                        'telefone_celular',
                        'telefone_fixo'];

        campos.forEach((campo) => {
          setFieldValue(campo, response.data[0][campo], false);
        })
      } 
    getFornecedor();
  } , [setFieldValue, id]);
  
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              select
              fullWidth
              label="Tipo de Pessoa"
              {...getFieldProps('tipo_pessoa')}
              error={Boolean(touched.tipo_pessoa && errors.tipo_pessoa)}
              helperText={touched.tipo_pessoa && errors.tipo_pessoa}
            >
              <MenuItem value ="1">Física</MenuItem>
              <MenuItem value ="2">Jurídica</MenuItem> 
            </TextField>
            <TextField 
                fullWidth
                label="CNPJ/CPF"
                {...getFieldProps('cnpj_cpf')}
                error={Boolean(touched.cnpj_cpf && errors.cnpj_cpf)}
                helperText={touched.cnpj_cpf && errors.cnpj_cpf}
                onChange={handleChange}
                onBlur={handleBlur}
                value={mask(unMask(formik.values.cnpj_cpf), ['999.999.999-99','99.999.999/9999-99'])}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Nome"
              {...getFieldProps('nome_fantasia')}
              error={Boolean(touched.nome_fantasia && errors.nome_fantasia)}
              helperText={touched.nome_fantasia && errors.nome_fantasia}
            />
            <TextField
              fullWidth
              label="Razão Social"
              {...getFieldProps('razao_social')}
              error={Boolean(touched.razao_social && errors.razao_social)}
              helperText={touched.razao_social && errors.razao_social}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Endereço"
              {...getFieldProps('endereco')}
              error={Boolean(touched.endereco && errors.endereco)}
              helperText={touched.endereco && errors.endereco}
            />
            <TextField
              fullWidth
              label="Número"
              {...getFieldProps('numero')}
              error={Boolean(touched.numero && errors.numero)}
              helperText={touched.numero && errors.numero}
            />
            <TextField
              fullWidth
              label="Complemento"
              {...getFieldProps('complemento')}
              error={Boolean(touched.complemento && errors.complemento)}
              helperText={touched.complemento && errors.complemento}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Bairro"
              {...getFieldProps('bairro')}
              error={Boolean(touched.bairro && errors.bairro)}
              helperText={touched.bairro && errors.bairro}
            />
            <TextField
              fullWidth
              label="Cidade"
              {...getFieldProps('cidade')}
              error={Boolean(touched.cidade && errors.cidade)}
              helperText={touched.cidade && errors.cidade}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Estado"
              {...getFieldProps('estado')}
              error={Boolean(touched.estado && errors.estado)}
              helperText={touched.estado && errors.estado}
            />
            <TextField
              fullWidth
              label="UF"
              {...getFieldProps('uf')}
              error={Boolean(touched.uf && errors.uf)}
              helperText={touched.uf && errors.uf}
            />
            <TextField
              fullWidth
              label="Cep"
              {...getFieldProps('cep')}
              error={Boolean(touched.cep && errors.cep)}
              helperText={touched.cep && errors.cep}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Inscrição Municipal"
              {...getFieldProps('inscricao_municipal')}
              error={Boolean(touched.inscricao_municipal && errors.inscricao_municipal)}
              helperText={touched.inscricao_municipal && errors.inscricao_municipal}
            />
            <TextField
              fullWidth
              label="Inscrição Estadual"
              {...getFieldProps('inscricao_estadual')}
              error={Boolean(touched.inscricao_estadual && errors.inscricao_estadual)}
              helperText={touched.inscricao_estadual && errors.inscricao_estadual}
            />
          </Stack>
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label="E-mail"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Contato"
              {...getFieldProps('contato')}
              error={Boolean(touched.contato && errors.contato)}
              helperText={touched.contato && errors.contato}
            />
            <TextField
              fullWidth
              label="Telefone Celular"
              {...getFieldProps('telefone_celular')}
              error={Boolean(touched.telefone_celular && errors.telefone_celular)}
              helperText={touched.telefone_celular && errors.telefone_celular}
              onChange={handleChange}
              onBlur={handleBlur}
              value={mask(unMask(formik.values.telefone_celular), '(99)9.9999-9999')}
            />
            <TextField
              fullWidth
              label="telefone Fixo"
              {...getFieldProps('telefone_fixo')}
              error={Boolean(touched.telefone_fixo && errors.telefone_fixo)}
              helperText={touched.telefone_fixo && errors.telefone_fixo}
              onChange={handleChange}
              onBlur={handleBlur}
              value={mask(unMask(formik.values.telefone_fixo), '(99)9999-9999')}
            />
          </Stack>

          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Alterar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
